"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeathTouchAbilityHandler = exports.DeathTouchActorAbilityFactory = exports.DeathTouchAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const core_2 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class DeathTouchAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.DeathTouch;
        this.__typeName = "DeathTouch";
    }
}
exports.DeathTouchAbilityArgs = DeathTouchAbilityArgs;
let DeathTouchActorAbilityFactory = class DeathTouchActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("DeathTouch", "OneEnemies", 5);
    }
};
DeathTouchActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("DeathTouch")
], DeathTouchActorAbilityFactory);
exports.DeathTouchActorAbilityFactory = DeathTouchActorAbilityFactory;
let DeathTouchAbilityHandler = class DeathTouchAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Death", 180)
            ],
            onHitOrMiss: (sequence, { hit }) => sequence.push(new core_1.InstantVfxStepArgs(hit ? new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "feet")
                : LocationSelector_1.ActorVfxLocationSelector.Miss(selectedEnemy), "DarkLightning")),
            onHit(sequence) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_2.LinkedEffectsEffectArgs([
                        new core_2.SlowEffectArgs(10),
                        new core_2.VulnerabilityEffectArgs(5),
                        new core_2.CurseEffectArgs("Focus", 10),
                        new core_2.DarknessEffectArgs()
                    ], true),
                });
            }
        });
    }
};
DeathTouchAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.DeathTouch)
], DeathTouchAbilityHandler);
exports.DeathTouchAbilityHandler = DeathTouchAbilityHandler;
